
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M4.333 15.5h8.334c.46 0 .833-.392.833-.875v-8.71a1 1 0 0 0-.293-.708L9.793 1.793a1 1 0 0 0-.707-.293H4.333c-.46 0-.833.392-.833.875v12.25c0 .483.373.875.833.875"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M6.591 8.469h3.796M6.591 11.609h3.796"}})])
          )
        }
      }
    